<template>
  <v-layout class="fill-height">
    <!-- Navigation -->
    <v-navigation-drawer
      v-model="drawer"
      app
      floating
      clipped
      :color="$vuetify.breakpoint.lgAndUp ? 'surface': ''"
      :right="$vuetify.rtl"
      width="260"
    >
      <!-- Navigation menu -->
      <main-menu :menu="menu" />
      <div v-if="check_main">
        <v-divider></v-divider>
        <main-menu :menu="admin_menu" />
      </div>
    </v-navigation-drawer>

    <!-- Toolbar -->
    <v-app-bar
      app
      flat
      color="surface"
      class="app-bar-full"
      clipped-left
    >
      <v-card
        class="flex-grow-1 d-flex pa-1"
        tile
      >
        <div class="d-flex flex-grow-1 align-center">
          <v-app-bar-nav-icon class="d-lg-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

          <div class="d-flex px-1 align-center">
            <img src="/images/main-logo.png" height="48" alt="logo" class="mr-1">
          </div>

          <v-spacer></v-spacer>

          <toolbar-user />
        </div>
      </v-card>
    </v-app-bar>

    <v-container :fluid="!isContentBoxed" class="pt-3">
      <router-view class="py-2 fill-height"></router-view>
    </v-container>

    <v-footer app>
      <div class="overline">
        Copyright © 2024 {{ footer_name }}, All rights Reserved
      </div>
    </v-footer>
  </v-layout>
</template>

<script>
import config from '@/configs'
import MainMenu from '@/components/MainMenu'
import ToolbarUser from '@/components/ToolbarUser'
import menu from './menu'
import admin_menu from './admin_menu'

export default {
  components: {
    MainMenu,
    ToolbarUser,
  },
  data() {
    return {
      menu,
      admin_menu,
      config,
      drawer: null,
      isContentBoxed: false,
      check_main: false,
      footer_name: process.env.VUE_APP_FOOTER_NAME
    }
  },
  mounted: function () {
    this.axios
    .get(`${process.env.VUE_APP_API_ORIGIN}/account/check_main`, {
      params: { email: this.$store.getters.getEmail }
    })
    .then(res => {
      this.check_main = res.data.is_main
    })
    .catch(() => {
      alert(e)
    })
  }
}
</script>

<style lang="scss">
.app-bar-full {
  .v-toolbar__content,
  .v-toolbar__extension {
    padding: 0;
  }
}
</style>
